













































import { Component, Vue, PropSync } from 'vue-property-decorator'
import SystemConstants from '@/constants/SystemConstants'
import SearchRequestNoDialogComponent from '@/components/SearchRequestNoDialogComponent.vue'
import { LoginStateModule } from '@/store/modules/LoginStateModule'
import { BadgeStateModule } from '@/store/modules/BadgeStateModule'
import MenusService from '@/service/MenusService'
import { LoginUser } from '@/domain/LoginUser'

@Component({
  components: {
    SearchRequestNoDialogComponent,
  },
})
export default class HeaderComponent extends Vue {
  menusService = MenusService.instance
  systemConstants = SystemConstants

  @PropSync("drawer", { type: Boolean, default: false, required: true })
  syncDrawer!: boolean

  searchRequestNoDialog = false

  /**
   * 有効な業務メニューを取得
   */
  get menus() {
    return this.menusService.menus
  }

  /**
   * 有効なメニューを取得
   */
  get items() {
    return this.menusService.menuBarItems
  }

  /**
   * ログイン状態を取得
   */
  get isLogin() {
    return LoginStateModule.isLogin
  }

  /**
   * ログイン名を取得
   */
  get loginUserName() {
    return LoginStateModule.loginUserName
  }

  /**
   * 未検査バッジの表示数
   */
  get inspectionCount() {
    const chemistryInspectionCount = BadgeStateModule.chemistryInspectionCount
    const microbialInspectionCount = BadgeStateModule.microbialInspectionCount
    switch (this.getUserDepartmentCode()) {
      case "01":
        /* 理化学 */
        return chemistryInspectionCount
      case "02":
        /* 微生物 */
        return microbialInspectionCount
      default:
        /* その他は表示しない */
        return 0
    }
  }

  /**
   * ログインユーザの権限
   */
  private getUserDepartmentCode(): string {
      const user = sessionStorage.getItem("loginUser")
      if (user === null) {
          return ""
      }
      return (JSON.parse(user) as LoginUser).departmentCode
  }

  /**
   * 受付番号検索
   */
  searchRequestNo() {
    this.searchRequestNoDialog = true
  }

  /**
   * 受付番号検索実行
   */
  onSearchRequestNo(event: string) {
    this.$router.push("/member/request/list")
    this.$router.replace("/member/request/edit/" + event)
  }

  /**
   * リロード（最新化）
   */
  reload() {
    this.$router.replace("/")
    window.location.reload()
  }
}
